import CameraPanel from '../../cameras/CameraPanel';
import { WidgetCamerasProps } from '../Dashboard.types';

const DashboardWidgetCameras = ({ widget }: { widget?: WidgetCamerasProps }) => {
 return <CameraPanel cameraId={widget?.camera?.Id ?? null} />;
};

export default DashboardWidgetCameras;
